/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Keyword_Optimizer_Cliche_Col_LocationInputs */

const en_keyword_optimizer_cliche_col_location = /** @type {(inputs: Keyword_Optimizer_Cliche_Col_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Location`)
};

const de_keyword_optimizer_cliche_col_location = /** @type {(inputs: Keyword_Optimizer_Cliche_Col_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Location`)
};

const fr_keyword_optimizer_cliche_col_location = /** @type {(inputs: Keyword_Optimizer_Cliche_Col_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Location`)
};

const es_keyword_optimizer_cliche_col_location = /** @type {(inputs: Keyword_Optimizer_Cliche_Col_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Location`)
};

const it_keyword_optimizer_cliche_col_location = /** @type {(inputs: Keyword_Optimizer_Cliche_Col_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Location`)
};

const nl_keyword_optimizer_cliche_col_location = /** @type {(inputs: Keyword_Optimizer_Cliche_Col_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Location`)
};

const pl_keyword_optimizer_cliche_col_location = /** @type {(inputs: Keyword_Optimizer_Cliche_Col_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Location`)
};

const fi_keyword_optimizer_cliche_col_location = /** @type {(inputs: Keyword_Optimizer_Cliche_Col_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Location`)
};

const da_keyword_optimizer_cliche_col_location = /** @type {(inputs: Keyword_Optimizer_Cliche_Col_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Location`)
};

const sv_keyword_optimizer_cliche_col_location = /** @type {(inputs: Keyword_Optimizer_Cliche_Col_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Location`)
};

/**
* | output |
* | --- |
* | "Location" |
*
* @param {Keyword_Optimizer_Cliche_Col_LocationInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const keyword_optimizer_cliche_col_location = /** @type {((inputs?: Keyword_Optimizer_Cliche_Col_LocationInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Keyword_Optimizer_Cliche_Col_LocationInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_keyword_optimizer_cliche_col_location(inputs)
	if (locale === "fr") return fr_keyword_optimizer_cliche_col_location(inputs)
	if (locale === "es") return es_keyword_optimizer_cliche_col_location(inputs)
	if (locale === "it") return it_keyword_optimizer_cliche_col_location(inputs)
	if (locale === "nl") return nl_keyword_optimizer_cliche_col_location(inputs)
	if (locale === "pl") return pl_keyword_optimizer_cliche_col_location(inputs)
	if (locale === "fi") return fi_keyword_optimizer_cliche_col_location(inputs)
	if (locale === "da") return da_keyword_optimizer_cliche_col_location(inputs)
	if (locale === "sv") return sv_keyword_optimizer_cliche_col_location(inputs)
	return en_keyword_optimizer_cliche_col_location(inputs)
});